module.exports = require("regenerator-runtime");



// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/regenerator/index.js